import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-519667f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-action float-end"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-signature me-2" }, null, -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลโครงการ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อมูลรายละเอียดข้อมูลโครงการ", -1))
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "card card-sub mt-2 mb-3" }
const _hoisted_19 = { class: "card-body pb-0" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins me-2" }),
  /*#__PURE__*/_createTextVNode("ปีงบประมาณ:")
], -1))
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle me-2" }),
  /*#__PURE__*/_createTextVNode("จังหวัด:")
], -1))
const _hoisted_26 = { class: "text-muted" }
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-th-large me-2" }),
  /*#__PURE__*/_createTextVNode("ประเภทโครงการ:")
], -1))
const _hoisted_29 = { class: "text-muted" }
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารของโครงการ:")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-sm-6 mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-invoice-dollar me-2" }),
  /*#__PURE__*/_createTextVNode("การจัดสรรงบประมาณ:")
], -1))
const _hoisted_37 = { class: "card card-sub mt-2" }
const _hoisted_38 = { class: "card-body my-0 pb-0" }
const _hoisted_39 = { class: "table mb-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ประเภท"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จำนวนเงิน")
  ])
], -1))
const _hoisted_41 = { class: "text-muted text-end" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  colspan: "2"
}, "รวมทั้งสิ้น", -1))
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = { class: "col-sm-6 mb-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-file-signature me-2" }),
  /*#__PURE__*/_createTextVNode("การอนุมัติโครงการ:")
], -1))
const _hoisted_46 = { class: "card card-sub mt-2" }
const _hoisted_47 = { class: "card-body mb-0" }
const _hoisted_48 = {
  key: 0,
  class: "row"
}
const _hoisted_49 = { class: "col-auto d-flex justify-content-center align-items-center" }
const _hoisted_50 = { class: "photo text-center" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "col" }
const _hoisted_53 = { class: "mb-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }),
  /*#__PURE__*/_createTextVNode("ผู้อนุมัติโครงการ:")
], -1))
const _hoisted_55 = { class: "text-muted" }
const _hoisted_56 = { class: "mb-3" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-certificate me-2" }),
  /*#__PURE__*/_createTextVNode("ตำแแหน่ง:")
], -1))
const _hoisted_58 = { class: "text-muted" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่อนุมัติโครงการ:")
], -1))
const _hoisted_60 = { class: "text-muted mb-0" }
const _hoisted_61 = {
  key: 1,
  class: "text-muted mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectAttachmentOffcanvasComponent = _resolveComponent("ProjectAttachmentOffcanvasComponent")!
  const _component_ProjectModalComponent = _resolveComponent("ProjectModalComponent")!
  const _component_ApprovementModalComponent = _resolveComponent("ApprovementModalComponent")!
  const _component_ProjectAttachmentModalComponent = _resolveComponent("ProjectAttachmentModalComponent")!
  const _component_ProjectAttachmentFormComponent = _resolveComponent("ProjectAttachmentFormComponent")!
  const _component_ProjectImageModalComponent = _resolveComponent("ProjectImageModalComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isOrs || ((_ctx.isMinister || _ctx.isProvince) && !_ctx.project?.isCanceled && !_ctx.project?.isFinished))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("ul", _hoisted_5, [
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
                      }, [
                        _hoisted_7,
                        _createTextVNode("แก้ไขข้อมูลโครงการ ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.approvementClick && _ctx.approvementClick(...args)))
                      }, [
                        _hoisted_9,
                        _createTextVNode("แก้ไขข้อมูลอนุมัติ ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.attachmentClick && _ctx.attachmentClick(...args)))
                      }, [
                        _hoisted_11,
                        _createTextVNode("จัดการเอกสารแนบ ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
                      }, [
                        _hoisted_13,
                        _createTextVNode("จัดการรูปภาพประกอบ ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_14,
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.project?.fiscalYear.name.replace('ปีงบประมาณ ', '')), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.project?.province.name), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.project?.projecType.name), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAttachment && _ctx.showAttachment(...args)), ["stop","prevent"]))
                    }, " ดูเอกสารของโครงการ ")
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_32,
                _withDirectives(_createElementVNode("p", _hoisted_33, null, 512), [
                  [_directive_dompurify_html, _ctx.project?.description ? _ctx.project?.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-']
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("table", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project?.projectBudgets, (budget, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(budget.shortName), 1),
                        _createElementVNode("td", _hoisted_41, _toDisplayString(Number(budget.amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_42,
                      _createElementVNode("td", _hoisted_43, _toDisplayString(Number(_ctx.project?.projectBudgets.reduce((total, m) => total + (m.amount ? m.amount : 0), 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                (_ctx.project?.projectApprovement)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("img", {
                            class: "photo-image",
                            src: _ctx.photoPreview,
                            width: "60",
                            height: "70",
                            alt: "preview"
                          }, null, 8, _hoisted_51)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.project?.projectApprovement.ministerName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.project?.projectApprovement.ministerPosition), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_59,
                          _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.thaiDate(_ctx.project.projectApprovement.approvedDate)), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_61, "ยังไม่มีข้อมูลอนุมัติโครงการ กรุณาเพิ่มข้อมูลผ่านเมนู \"แก้ไขข้อมูลอนุมัติ\""))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ProjectAttachmentOffcanvasComponent, {
      ref: "projectAttachmentOffcanvas",
      "project-id": _ctx.project?.id
    }, null, 8, ["project-id"]),
    _createVNode(_component_ProjectModalComponent, {
      ref: "projectModal",
      "project-id": _ctx.project?.id,
      onValidated: _ctx.updateProject
    }, null, 8, ["project-id", "onValidated"]),
    _createVNode(_component_ApprovementModalComponent, {
      ref: "approvementModal",
      "project-id": _ctx.project?.id,
      onValidated: _ctx.updateApprovement
    }, null, 8, ["project-id", "onValidated"]),
    _createVNode(_component_ProjectAttachmentModalComponent, {
      ref: "projectAttachmentModel",
      "project-id": _ctx.project?.id,
      onUpload: _ctx.uploadClick
    }, null, 8, ["project-id", "onUpload"]),
    _createVNode(_component_ProjectAttachmentFormComponent, {
      ref: "projectAttachmentForm",
      "project-id": _ctx.project?.id,
      onHidden: _ctx.uploadClose
    }, null, 8, ["project-id", "onHidden"]),
    _createVNode(_component_ProjectImageModalComponent, {
      ref: "projectImageModal",
      "project-id": _ctx.project?.id
    }, null, 8, ["project-id"])
  ], 64))
}